import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import RouteLoadingFallback from './infrastructure/RouteLoadingFallback.js'

function SiteAdminProtected({ isAuthenticated, authChecked, userRoles, children }) {
    const location = useLocation()
    
    if (!authChecked || (isAuthenticated && userRoles == null)) {
        return <RouteLoadingFallback />
    }
    
    if (!isAuthenticated) {
        return <Navigate to="/loginWithGoogle" replace state={{ from: location.pathname }} />
    }
    
    // Check if user has siteAdmin role
    if (!userRoles?.siteAdmin) {
        return (
            <div className="alert alert-danger text-center mt-5">
                <h3>Access Denied</h3>
                <p>You don't have permission to access this page.</p>
                <p>Site administrator access required.</p>
                <div className="mt-3">
                    <button 
                        className="btn btn-primary"
                        onClick={() => window.history.back()}
                    >
                        Go Back
                    </button>
                </div>
            </div>
        )
    }
    
    return children
}

export default SiteAdminProtected
